import Vue from "vue";
import { filtrosVazios } from "../types/processo-eletronico/filtro-processo-eletronico";

/**
 * Armazena os dados da antiga mesa de interessado, atualmente
 * chamada de 'meus protocolos e processos'.
 *
 * @since 20220601
 */
export const storeMeusProtocolosProcessos = Vue.observable({
  filtros: {
    ...filtrosVazios,
  },
  totalRows: 0,
  currentPage: 1,
  items: [],
});

/**
 * Armazena os dados da antiga mesa de UG, atualmente
 * chamada de 'protocolos e processos da UG'.
 *
 * @since 20220607
 */
export const storeProtocolosProcessosUG = Vue.observable({
  filtros: {
    ...filtrosVazios,
  },
  totalRows: 0,
  currentPage: 1,
  items: [],
});

/**
 * Armazena os dados da consulta de Advogado
 *
 * @since 20220607
 */
export const storeProtocolosProcessosAdv = Vue.observable({
  filtros: {
    ...filtrosVazios,
    dataEntrada: { startDate: null, endDate: null },
  },
  totalRows: 0,
  currentPage: 1,
  items: [],
});

/**
 * Armazena os dados da consulta de Administrador
 *
 * @since 20220607
 */
export const storeProtocolosProcessosAdm = Vue.observable({
  filtros: {
    ...filtrosVazios,
  },
  totalRows: 0,
  currentPage: 1,
  items: [],
});

export const limparStoreUG = () => {
  storeProtocolosProcessosUG.filtros = { ...filtrosVazios };
  storeProtocolosProcessosUG.totalRows = 0;
  storeProtocolosProcessosUG.currentPage = 1;
  storeProtocolosProcessosUG.items = [];
};

export const limparStoreMeusProtocolos = () => {
  storeMeusProtocolosProcessos.filtros = { ...filtrosVazios };
  storeMeusProtocolosProcessos.totalRows = 0;
  storeMeusProtocolosProcessos.currentPage = 1;
  storeMeusProtocolosProcessos.items = [];
};

export const limparStoreAdv = () => {
  storeProtocolosProcessosAdv.filtros = { ...filtrosVazios, dataEntrada: { startDate: null, endDate: null }, };
  storeProtocolosProcessosAdv.totalRows = 0;
  storeProtocolosProcessosAdv.currentPage = 1;
  storeProtocolosProcessosAdv.items = [];
};

export const limparStoreAdm = () => {
  storeProtocolosProcessosAdm.filtros = { ...filtrosVazios };
  storeProtocolosProcessosAdm.totalRows = 0;
  storeProtocolosProcessosAdm.currentPage = 1;
  storeProtocolosProcessosAdm.items = [];
};

export const limparTodasStoresProtocolos = () => {
  limparStoreUG()
  limparStoreMeusProtocolos()
  limparStoreAdv()
  limparStoreAdm()
}
